// extracted by mini-css-extract-plugin
module.exports = {"content":"SCypL","separator":"ASvov","title":"RgiEy","header":"Hy2L8","headerContent":"__9Sm9K","errorHeader":"zOvCa"};